/* eslint-disable */
import moment from 'moment';
import cogsAnalyticsServices from '@/Services/Analytics Services/cogsAnalytics.services';

export const fetchInitialData = async (state) => {
	const reqData = {
		dateFilter: { ...state?.dateFilter, dateType: 'scheduledAt' },
		grouping: { ...state?.grouping, type: state?.selectedTab === 'geographyWise' ? 'geographyWiseNew' : state?.selectedTab },
		dateRangeFilter: {},
		...(state?.selectedTab !== 'periodWise' && {
			dateRangeFilter: {
				dateType: 'scheduledAt',
				from: moment(state?.dateRangeObj?.from).format('YYYY-MM-DD'),
				to: moment(state?.dateRangeObj?.to).format('YYYY-MM-DD'),
			},
		}),
		analysisType: 'BOM',
		showInternalData: false,
		yAxis: state?.selectedChartTab,
		perUnit: state?.perUnitToggle,
		productIdsList: state?.filters?.product?.id
			? [state?.filters?.product?.id]
			: [],
		processIds: state?.filters?.processIds ?? [],
		shiftId: state?.filters?.type && state?.filters?.type !== -999 ? state?.filters?.type : null,
		storeFilter: state?.filters?.store?.id
			? [state?.filters?.store?.id]
			: [],
		hourWisePlot: (state?.filters?.timeTypeFilter === 'PerHour' || state?.filters?.timeTypeFilter === 'Cummulative') ? true : false,
		isBatchWiseMode: state?.dashboardMode === 'batchPerformance',
		...(state?.isCache ? { NO_CACHE: true } : {}),
	};
	const req = {
		data: {
			...reqData,
		},
	};
	const response = await cogsAnalyticsServices.fetchCogsAnalysisGraph({
		req,
	});
	if (state?.selectedTab === 'periodWise' &&
		state?.dateFilter?.currentSelection?.toLowerCase() === 'day' &&
		(state?.filters?.timeTypeFilter?.toLowerCase() === 'cummulative') &&
		Array.isArray(response?.data?.chartData?.dataset)) {
		const cummlativeChartData = response?.data?.chartData?.dataset?.map((ele) => {
			let cummlativeDataValue = 0;
			return {
				...ele,
				data: ele?.data?.map((item) => {
					cummlativeDataValue += item;
					return cummlativeDataValue;
				})
			}
		})

		const data = { chartData: { ...response?.data?.chartData, dataset: cummlativeChartData }, statsData: response?.data?.statsData, cacheTime: response?.cacheTime }
		return data
	}
	return { ...response?.data, cacheTime: response?.cacheTime };
};
